import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: stretch;
    height: 100%;
`;

export const Help = styled.a`
    position: absolute;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    top: 25px;
    left: 55px;
    z-index: 4;
    height: 20px;
    width: 20px;
    background-color: #000;
    border-radius: 10px;
    border: 1px solid #ccc;
    color: #ccc;
    transition: all .4s ease 0s;
    text-decoration: none;

    :before {
        content: '\\F02D6';
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        font-family: 'Material Design Icons';
        font-size: 10px;
    }

    :hover {
        color: #000;
        background-color: #ccc;
    }
`;